import { Card as BaseCard } from "@mui/material";
import styled from "@emotion/styled";
import isPropValid from "@emotion/is-prop-valid";

const Card = styled(BaseCard, {
  shouldForwardProp: (prop) => isPropValid(prop) || prop === "sx",
})(({ theme, disableZoom }) => ({
  boxShadow: 5,
  width: "fit-content",
  backgroundColor: theme.palette.primary.main,
  borderRadius: 10,
  transition: theme.transitions.create(["transform"], {
    duration: 250,
  }),
  willChange: "transform",
  backgroundImage: "unset",

  "& img": {
    transition: theme.transitions.create(["transform"], {
      duration: 250,
    }),
    willChange: "transform",
  },

  ...(!disableZoom
    ? {
        "&:hover": {
          transform: "scale(1.05)",

          "& img": {
            transform: "scale(1.05)",
          },
        },
      }
    : null),
}));

export { Card };
